import { Component, OnInit } from '@angular/core';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { Breadcrumb, GenerateTableColumn, GenerateTablePagination } from 'src/app/shared/components';
import { RelatorioService } from '../relatorio.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContratoService } from 'src/app/contrato';
import { BeneficiariaService } from 'src/app/beneficiaria/beneficiaria.service';

@Component({
    selector: 'app-prefixos-sem-dios',
    templateUrl: './prefixos-sem-dios.component.html',
    styleUrls: ['./prefixos-sem-dios.component.css'],
    standalone: false
})
export class PrefixosSemDiosComponent extends GenericRelatorioComponent implements OnInit {
  
  breadcrumb: Breadcrumb[] = [
    { label: 'Início' },
    { label: 'Relatórios', route: '/relatorio' },
    { label: 'Prefixos Sem DIO' },
  ]

  prefixos: any[] = [];  

  pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
  columns: GenerateTableColumn[] = [          
    { header: 'Prefixo', attr: 'prefixo' },          
  ];

  constructor(
    private relatorioService: RelatorioService,
    protected override beneficiariaService: BeneficiariaService,
    protected override snackBar: MatSnackBar,
  ) {
    super(beneficiariaService, snackBar);
  }

  ngOnInit(): void {
    this.filters.dataOperacao = new Date();
  }

  search(){
    if (!this.filters.beneficiaria) {
      this.snackBar.open('Selecione uma beneficiária', '✕', { panelClass: ['warning'] });
      return;
    }

    if (!this.filters.dataOperacao) {
      this.snackBar.open('Selecione uma data', '✕', { panelClass: ['warning'] });
      return;
    }

    this.loading = true;
    
    const beneficiariaId = (this.filters.beneficiaria as any)?.id || (this.filters.beneficiaria as any);
    const dataOperacao = this.filters.dataOperacao as Date;
    
    this.relatorioService.getRelatorioPrefixosSemDio(beneficiariaId, dataOperacao).subscribe({
      next: (res) => {
        console.log(res);
        this.prefixos = res;
      }
    }).add(() => this.loading = false);
  }

}
